import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { saveSelectedLocations, saveFilterGameUpdating } from "../redux/UserDataSlice";
import { useSelector } from "react-redux";
import { endpoint } from "../assets/api/endpoint";
import { apiHandler } from "../assets/api";
import axios from "axios";

const FilterLocation = ({ onLocationChange, gameFilter }) => {
    const { profileData, filterUpdating, filterGameUpdating, accessToken } = useSelector((state) => state?.loginInfo);

    const [locationResults, setLocationResults] = useState([]);
    const [otherLocation, setOtherLocation] = useState();
    const dispatch = useDispatch();
    const [selectedCoordinatesOther, setSelectedCoordinates] = useState({ latitude: null, longitude: null });
    const [otherLocatonModal, setOtherLocatonModal] = useState(false);
    const [selectedLocations, setSelectedLocations] = useState({
        profileLocation: false,
        currentLocation: false,
        others: false,
    });
    const [location, setLocation] = useState({ latitude: '', longitude: '' });
    const [currentLocation, setCurrentLocation] = useState("");
    const [profileLocation, setProfileLocation] = useState("");
    const [loading, setLoading] = useState();
    const [recentSearches, setRecentSearches] = useState(
        JSON.parse(localStorage.getItem("recentLocations")) || []
    );

    const handleLocationChange = (type) => {
        const newState = {
            profileLocation: false,
            currentLocation: false,
            others: false,
            [type]: true,
        };

        setSelectedLocations(newState);

        if (type === "others") {
            setOtherLocatonModal(true);
        }
    };


    const getLocationName = async (lat, lng) => {
        const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
        const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;

        try {
            const response = await fetch(url);
            const data = await response.json();

            if (data.status === 'OK') {
                const address = data.results[0]?.formatted_address;
                return address;
            } else {
                console.error('Geocoding error:', data.status);
                return null;
            }
        } catch (error) {
            console.error('Error fetching location:', error);
            return null;
        }
    };

    const handleSelectLocation = (loc) => {
        const selected = { name: loc.name, lat: loc.lat, lng: loc.lng };
        setRecentSearches(prev => {
            const updated = [selected, ...prev.filter(item => item.name !== selected.name)].slice(0, 5);
            localStorage.setItem('recentLocations', JSON.stringify(updated));
            return updated;
        });

        setSelectedCoordinates({ latitude: loc.lat, longitude: loc.lng });
        setOtherLocation(loc.name);
        setLocationResults([]);
        setLocation({ latitude: loc.lat, longitude: loc.lng });
        onLocationChange?.({ latitude: loc.lat, longitude: loc.lng })
    };

    useEffect(() => {
        if (selectedLocations.profileLocation) {
            setLocation({
                latitude: profileData?.baseProfile?.latitude,
                longitude: profileData?.baseProfile?.longitude
            });
            onLocationChange?.({
                latitude: profileData?.baseProfile?.latitude,
                longitude: profileData?.baseProfile?.longitude
            })
        } else if (selectedLocations.currentLocation) {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const { latitude, longitude } = position.coords;
                        getLocationName(latitude, longitude).then(setCurrentLocation);
                        setLocation({ latitude, longitude });
                        onLocationChange?.({ latitude, longitude })
                    },
                    (error) => {
                        console.error('Error fetching location:', error);
                    }
                );
            }
        }

        if (profileData?.baseProfile?.latitude && profileData?.baseProfile?.longitude) {
            getLocationName(profileData.baseProfile.latitude, profileData.baseProfile.longitude)
                .then(setProfileLocation);
        }
        setSelectedCoordinates({ latitude: null, longitude: null });
        dispatch(saveSelectedLocations(selectedLocations));

    }, [selectedLocations]);

    useEffect(() => {
        const fetchProfileFilterData = async () => {
            setLoading(true);
            try {
                const result = await apiHandler({
                    url: gameFilter ? endpoint.FETCH_GAME_FILTER_DATA : endpoint.FETCH_PROFILE_FILTER_DATA,
                    method: "GET",
                    authToken: accessToken?.accessToken
                });
                if (result.data) {

                    setLocation({
                        latitude: result.data.latitude,
                        longitude: result.data.longitude
                    });
                    const apiLat = result.data.latitude;
                    const apiLng = result.data.longitude;
                    const storedCoordinates = JSON.parse(localStorage.getItem("coordinates"));

                    setLocation({ latitude: apiLat, longitude: apiLng });
                    if (
                        apiLat === profileData?.baseProfile?.latitude &&
                        apiLng === profileData?.baseProfile?.longitude
                    ) {
                        setSelectedLocations({
                            profileLocation: true,
                            currentLocation: false,
                            others: false,
                        });
                    } else if (

                        apiLat === storedCoordinates?.latitude &&
                        apiLng === storedCoordinates?.longitude
                    ) {
                        setSelectedLocations({
                            profileLocation: false,
                            currentLocation: true,
                            others: false,
                        });
                    } else {
                        setSelectedLocations({
                            profileLocation: false,
                            currentLocation: false,
                            others: true,
                        });
                    }
                }
            } catch (error) {
                console.error("Error fetching filter data", error);
            } finally {
                setLoading(false);
            }
        };
        fetchProfileFilterData();
        dispatch(saveFilterGameUpdating(!filterGameUpdating))
    }, [filterUpdating]);

    useEffect(() => {
        const fetchLocation = async () => {
            if (otherLocation?.length >= 3) {
                try {
                    const response = await axios.get('https://maps.googleapis.com/maps/api/geocode/json', {
                        params: {
                            address: otherLocation,
                            key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
                        }
                    });

                    if (response?.data?.results && response.data.results.length > 0) {
                        const locations = response.data.results.map(result => ({
                            name: result?.formatted_address,
                            lat: result?.geometry?.location.lat,
                            lng: result?.geometry?.location.lng
                        }));
                        setLocationResults(locations);
                    } else {
                        setLocationResults([]);
                    }
                } catch (error) {
                    console.error('Error fetching location:', error);
                }
            } else {
                setLocationResults([]);
            }
        };

        const delayDebounceFn = setTimeout(fetchLocation, 500);

        return () => clearTimeout(delayDebounceFn);
    }, [otherLocation]);

    useEffect(() => {
        const stored = localStorage.getItem('recentLocations');
        if (stored) {
            setRecentSearches(JSON.parse(stored));
        }
    }, []);
    useEffect(() => {
        if (selectedLocations.others) {
            setSelectedCoordinates(location);
            getLocationName(location.latitude, location?.longitude)
                .then((address) => {
                    setOtherLocation(address);
                });
        }
    }, [selectedLocations.others]);

    return (
        <>
            <div className="form-check mb-2 profile-location-card">
                <input
                    className="form-check-input"
                    type="checkbox"
                    id="profileLocation"
                    checked={selectedLocations.profileLocation === true}
                    onChange={() => handleLocationChange("profileLocation")}
                />
                <label className="form-check-label d-sm-flex justify-content-between filter-skill-level" htmlFor="profileLocation">
                    <span className="d-block  fw-semibold">Profile Location</span> <span>{profileData?.baseProfile?.city}</span>
                </label>
            </div>

            <div className="form-check mb-2 profile-location-card">
                <input
                    className="form-check-input"
                    type="checkbox"
                    id="currentLocation"
                    checked={selectedLocations.currentLocation === true}
                    onChange={() => handleLocationChange("currentLocation")}
                />
                <label className="form-check-label d-sm-flex justify-content-between filter-skill-level" htmlFor="currentLocation">
                    <span className="d-block  fw-semibold me-0 me-sm-2 ">Current Location</span> <span>{currentLocation}</span>
                </label>
            </div>

            <div className="form-check mb-4 profile-location-card">
                <input
                    className="form-check-input"
                    type="checkbox"
                    id="others"
                    checked={selectedLocations.others}
                    onChange={() => handleLocationChange("others")}
                />
                <label className="form-check-label d-sm-flex justify-content-between filter-skill-level" htmlFor="others">
                    <span className="d-block  fw-semibold">Others</span> <span>{otherLocation}</span>
                </label>
            </div>

            {selectedLocations.others && otherLocatonModal && (
                <div className="modal bottom-modal show d-block" tabIndex="-1" role="dialog">
                    <div className="modal-dialog modal-dialog-scrollable" role="document">
                        <div className="modal-content modal-content-scrollable">
                            <div className="modal-header">
                                <h5 className="modal-title">Search Location</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setOtherLocatonModal(false)}
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="location-search-container">
                                    <input
                                        type="text"
                                        placeholder="Enter location"
                                        value={otherLocation}
                                        onChange={(e) => setOtherLocation(e.target.value)}
                                        className="border p-2 w-full"
                                        style={{ width: '75%', borderRadius: '10px' }}
                                    />

                                    {!selectedCoordinatesOther?.latitude && otherLocation && locationResults?.length > 0 && (
                                        <div className="other-location-pop-up p-3 bg-white border mt-2 rounded shadow">
                                            {locationResults.map((loc, index) => (
                                                <div
                                                    key={index}
                                                    onClick={() => handleSelectLocation(loc)}
                                                    className="location-item cursor-pointer p-2 hover:bg-gray-100"
                                                >
                                                    {loc.name}
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {otherLocation?.length < 3 && recentSearches?.length > 0 && (
                                        <div className="other-location-pop-up p-3 bg-white border mt-2 rounded shadow">
                                            <div className="text-sm font-semibold mb-2">Recent Searches:</div>
                                            {recentSearches.map((loc, index) => (
                                                <div
                                                    key={index}
                                                    onClick={() => handleSelectLocation(loc)}
                                                    className="location-item cursor-pointer p-2 hover:bg-gray-100"
                                                >
                                                    {loc.name}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default FilterLocation;
